import { useEffect, useState } from 'react'

import { refundMethods as allowedRefundMethods } from '@reveni-io/reveni-ui'

const useRefundMethod = ({ refundMethods, refundMethodOptions, disabledPreselectedRefundMethod }) => {
  const [refundMethodSelected, setRefundMethodSelected] = useState(null)

  useEffect(() => {
    const singleRefundMethod = refundMethods?.length === 1
    const hasBankTransferInstant = refundMethods?.find(
      rm => rm.name === allowedRefundMethods.bankTransfer && rm.is_instant
    )

    if (!disabledPreselectedRefundMethod && !refundMethodSelected) {
      if (singleRefundMethod || !hasBankTransferInstant) {
        setRefundMethodSelected(refundMethodOptions[0]?.value)
      } else {
        setRefundMethodSelected(allowedRefundMethods.bankTransfer)
      }
    } else if (disabledPreselectedRefundMethod && singleRefundMethod) {
      setRefundMethodSelected(refundMethodOptions[0]?.value)
    }
  }, [disabledPreselectedRefundMethod, refundMethodOptions, refundMethodSelected, refundMethods])

  return { refundMethodSelected, setRefundMethodSelected }
}

export default useRefundMethod
